document.documentElement.classList.add('js');
(function(){
const vehicles={
'Acura':['Integra','RSX','TL','TLX','NSX'],
'Audi':['A3','A4','A5','S3','S4','S5','RS3','RS5','Q5'],
'BMW':['2 Series','3 Series','4 Series','5 Series','M2','M3','M4','M5','X3','X5'],
'Chevrolet':['Camaro','Corvette','Silverado 1500','Silverado 2500HD','Silverado 3500HD','Tahoe','Suburban'],
'Dodge':['Challenger','Charger','Durango'],
'Ford':['Mustang','F-150','F-250','F-350','Bronco','Ranger','Focus','Explorer'],
'GMC':['Sierra 1500','Sierra 2500HD','Sierra 3500HD','Yukon','Canyon'],
'Honda':['Civic','Accord','S2000','Prelude','CR-V'],
'Hyundai':['Elantra N','Veloster N','Genesis Coupe','Sonata'],
'Infiniti':['G35','G37','Q50','Q60'],
'Jeep':['Wrangler','Gladiator','Grand Cherokee'],
'Lexus':['IS','GS','RC','IS F','RC F'],
'Mazda':['MX-5 Miata','RX-7','RX-8','Mazda3'],
'Mitsubishi':['Lancer Evolution','Eclipse','3000GT','Lancer'],
'Nissan':['240SX','350Z','370Z','Z','GT-R','Frontier','Titan','Sentra'],
'Ram':['1500','2500','3500'],
'Subaru':['WRX','WRX STI','BRZ','Forester','Outback'],
'Toyota':['Supra','GR86','86','GR Corolla','Corolla','Camry','Tacoma','Tundra','4Runner','Land Cruiser'],
'Volkswagen':['Golf GTI','Golf R','Jetta GLI','Arteon']
};
const option=(value,label)=>{const o=document.createElement('option');o.value=value;o.textContent=label||value;return o;};
document.querySelectorAll('[data-vehicle-finder]').forEach(form=>{
const year=form.querySelector('[data-vehicle-year]'),make=form.querySelector('[data-vehicle-make]'),model=form.querySelector('[data-vehicle-model]'),q=form.querySelector('[name=q]');
const current=new Date().getFullYear()+1;
for(let y=current;y>=1980;y--)year.appendChild(option(String(y)));
const reset=(select,placeholder)=>{select.replaceChildren(option('',placeholder));select.disabled=true;};
year.addEventListener('change',()=>{reset(make,'Select make');reset(model,'Select model');if(year.value){Object.keys(vehicles).sort().forEach(m=>make.appendChild(option(m)));make.disabled=false;}});
make.addEventListener('change',()=>{reset(model,'Select model');if(make.value){vehicles[make.value].forEach(m=>model.appendChild(option(m)));model.disabled=false;}});
form.addEventListener('submit',e=>{if(!year.value||!make.value||!model.value){e.preventDefault();form.reportValidity();return;}q.value=[year.value,make.value,model.value].join(' ');});
});
})();